import { render } from "./Coll.vue?vue&type=template&id=2832d9d1&scoped=true"
import script from "./Coll.vue?vue&type=script&lang=js"
export * from "./Coll.vue?vue&type=script&lang=js"

import "./Coll.vue?vue&type=style&index=0&id=2832d9d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2832d9d1"]])

export default __exports__